import { createGlobalStyle, css } from 'styled-components'

export const theme = {
  color: {
    bg: '#F5EFED',
    black: '#00233D',
    accent: '#23456E',
    grey: '#AEB6BF',
    white: '#FFFFFF',
  },
  font: {
    jp: `
      YuGothic,
      "Yu Gothic", 
      "Noto Sans JP",
      "Hiragino Kaku Gothic ProN",
      "Hiragino Sans",
      HelveticaNeue,
      "Helvetica Neue",
      Arial,
      Meiryo,
      san-serif
    `,
    en: `Futura, YuGothic, "Yu Gothic", san-serif`
  },
  breakpoints: {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1280,
  },
  containerMaxWidth: {
    sm: 540,
    md: 720,
    lg: 960,
    xl: 1250,
  },
}

export default createGlobalStyle`
  ${({ theme: { color, font, breakpoints }}) => css`
    * {
      margin: 0;
      padding: 0;
    }
    *, *::after, *::before {
      box-sizing: border-box;
    }
    html {
      font-size: 50%;
      overflow-y: scroll;
      overscroll-behavior: none;
      margin: 0;
      padding: 0;
      @media (min-width: ${breakpoints.md}px) {
        font-size: 62.5%;
      }
    }
    body {
      font-family: ${font.jp};
      font-size: 1.6em;
      color: ${color.black};
      background-color: ${color.bg};
      letter-spacing: 0.15rem;
    }
    h2 {
      font-family: ${font.en};
      font-size: 3.2rem;
      font-weight: 500;
      letter-spacing: 0.05em;
      // @media (min-width: ${breakpoints.md}px) {
      //   font-size: 3.2rem;
      // }
    }
    h3 {
      font-size: 2.2rem;
      font-weight: 700;
      // line-height: 2.0;
      // @media (min-width: ${breakpoints.md}px) {
      //   font-size: 2.2rem;
      // }
    }
    h4 {
      margin: 0;
    }
    p {
      font-size: 1.6rem;
      line-height: 1.9;
      margin: 0;
      // @media (min-width: ${breakpoints.md}px) {
      //   font-size: 1.4rem;
      // }
    }
    ul {
      padding: 0;
    }
    li {
      font-size: 1.6rem;
      line-height: 1.6rem;
      list-style-type: none;
    }
    a {
      font-size: 1.6rem;
      color: ${color.accent};
    }
    button {
      background: none;
      border: none;
      outline: none;
      cursor: pointer;
    }
    ::selection {
      background: ${color.accent};
      color: #fff;
    }
  `}
`